const apartmentsCategorySelectJs = function () {

    $('.js--apartment-category-select-col').hover(function(){
        let colNumber = $(this).data('col');
      $('.js--apartment-category-select-columns-wrapper, .js--apartment-category-select-columns')
        .addClass('is--col-'+colNumber)
        .addClass('is--hover');

    }, function() {
      removeHoverClasses();
    });

    $('.js--apartment-category-select-back-button').click(function(e){
      e.preventDefault();
      removeHoverClasses();
    })

    function removeHoverClasses() {
      $('.js--apartment-category-select-columns-wrapper, .js--apartment-category-select-columns')
        .removeClass('is--col-0')
        .removeClass('is--col-1')
        .removeClass('is--col-2')
        .removeClass('is--col-3')
        .removeClass('is--hover')
      ;
    }
}

export default apartmentsCategorySelectJs;
